import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export async function fetchJSON(path, opts = {}) {
  const r = await api({ url: path, ...opts });
  return r.data;
}
